import React, { useContext, useState, useEffect, useRef } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import styles from "./Header.module.css";
import FunctionalButton from "../button/FunctionalButton";

function Header({ showNavigation, specsheetStyle = false }) {
  const [role, setRole] = useState("");
  const { signOut, user } = useContext(AuthContext);
  let navigate = useNavigate();

  const blueContainer = useRef();

  // Based on the user role we show a specified menu
  useEffect(() => {
    async function confirmUser() {
      setRole(user.role);
    }
    if (user !== null) {
      confirmUser();
    }
  }, [user]);

  // When clicking the logo go to the search page (this is the main page after login).
  function goToSearchPage() {
    navigate("/search");
  }

  // On the day before Kingsday and on Kingsday itself we change the blue containter to orange just like in the previewer.
  useEffect(() => {
    const date = new Date();
    const currentDay = date.getDate();
    const currentMonth = date.getMonth() + 1;
    if (
      (currentDay === 26 && currentMonth === 4) ||
      (currentDay === 27 && currentMonth === 4)
    ) {
      blueContainer.current.style.backgroundColor = "var(--kingsday-orange)";
    }
  }, []);

  return (
    <div className={styles["navigation-container"]}>
      <div
        className={`${styles["blue-container"]} ${specsheetStyle ? styles.headerRedesign : ""}`}
        ref={blueContainer}
      >
        <div
          className={`${styles["header-container"]} ${specsheetStyle ? styles.headerRedesignInner : ""}`}
        >
          {showNavigation && (
            <div
              className={styles["logo-container"]}
              id={styles["logo-container"]}
              onClick={goToSearchPage}
            >
              <svg className={styles["w-logo"]} viewBox="0 0 1005 285">
                <path fill="#fff" d="M114,84.2C67.3,51.6-1.5,88.4,0,145.5c-1.5,57.1,67.3,93.9,114,61.3v12.2h33V72h-33v12.2h0ZM73.5,186.1c-53.2-1-53.2-80.1,0-81,53.2,1,53.2,80.1,0,81Z"/>
                <path fill="#fff" d="M662.9,84.2c-46.7-32.6-115.5,4.2-114,61.3-1.5,57.1,67.3,93.9,114,61.3v12.2h33V72h-33v12.2h0ZM622.4,186.1c-53.2-1-53.2-80.1,0-81,53.2,1,53.2,80.1,0,81Z"/>
                <path fill="#fff" d="M928.4,129.1h0c-26.9-1.3-33-3.5-40.2-12.1,5.7-15.8,71.5-15,79-2h34.6c-4.1-30.2-37.3-43.8-73.5-43-98.7.5-98.7,89.6,0,90,26.9,1.2,33,3.4,40.2,12-5.8,15.8-71.9,15.2-79.3,1.7h-34.4c3.9,30.4,37.1,44.1,73.5,43.4,98.7-.5,98.7-89.6,0-90h.1Z"/>
                <path fill="#fff" d="M276,84.2c-49.4-34.6-121.5,8.9-113.6,68.8,3.8,53.5,69.9,84.7,113.6,53.8v12.2h33V0h-33v84.2h0ZM281.6,145.2h0c-3.8,6.4-15.1,13.3-33.6,24.7-19.1,10.4-30.8,16.6-38.2,16.7-4.7-9.5-4.7-72.5,0-82,10.6-1.5,65.6,32.1,71.8,40.6h0Z"/>
                <path fill="#fff" d="M822.5,72.1l-38,81.6-38-81.6h-36.4l56,120.4c-12.1,20.4-33.6,55.5-55.1,56.4v33.2c78.3-5.9,115.4-154.8,147.9-210,0,0-36.4,0-36.4,0Z"/>
                <polygon fill="#fff" points="486.5 158.8 456.9 72.1 410.1 72.1 380.5 158.8 358.3 72.1 323.6 72.1 361.2 219.1 395.5 219.1 433.5 107.7 471.5 219.1 505.8 219.1 543.4 72.1 508.7 72.1 486.5 158.8"/>
              </svg>
            </div>
          )}

          {!showNavigation && (
            <div className={styles["logo-container"]}>
              <svg className={styles["w-logo"]} viewBox="0 0 1005 285">
                <path fill="#fff" d="M114,84.2C67.3,51.6-1.5,88.4,0,145.5c-1.5,57.1,67.3,93.9,114,61.3v12.2h33V72h-33v12.2h0ZM73.5,186.1c-53.2-1-53.2-80.1,0-81,53.2,1,53.2,80.1,0,81Z"/>
                <path fill="#fff" d="M662.9,84.2c-46.7-32.6-115.5,4.2-114,61.3-1.5,57.1,67.3,93.9,114,61.3v12.2h33V72h-33v12.2h0ZM622.4,186.1c-53.2-1-53.2-80.1,0-81,53.2,1,53.2,80.1,0,81Z"/>
                <path fill="#fff" d="M928.4,129.1h0c-26.9-1.3-33-3.5-40.2-12.1,5.7-15.8,71.5-15,79-2h34.6c-4.1-30.2-37.3-43.8-73.5-43-98.7.5-98.7,89.6,0,90,26.9,1.2,33,3.4,40.2,12-5.8,15.8-71.9,15.2-79.3,1.7h-34.4c3.9,30.4,37.1,44.1,73.5,43.4,98.7-.5,98.7-89.6,0-90h.1Z"/>
                <path fill="#fff" d="M276,84.2c-49.4-34.6-121.5,8.9-113.6,68.8,3.8,53.5,69.9,84.7,113.6,53.8v12.2h33V0h-33v84.2h0ZM281.6,145.2h0c-3.8,6.4-15.1,13.3-33.6,24.7-19.1,10.4-30.8,16.6-38.2,16.7-4.7-9.5-4.7-72.5,0-82,10.6-1.5,65.6,32.1,71.8,40.6h0Z"/>
                <path fill="#fff" d="M822.5,72.1l-38,81.6-38-81.6h-36.4l56,120.4c-12.1,20.4-33.6,55.5-55.1,56.4v33.2c78.3-5.9,115.4-154.8,147.9-210,0,0-36.4,0-36.4,0Z"/>
                <polygon fill="#fff" points="486.5 158.8 456.9 72.1 410.1 72.1 380.5 158.8 358.3 72.1 323.6 72.1 361.2 219.1 395.5 219.1 433.5 107.7 471.5 219.1 505.8 219.1 543.4 72.1 508.7 72.1 486.5 158.8"/>
              </svg>
            </div>
          )}
          {showNavigation && (
            <nav>
              {user && (
                <ul>
                  <>
                    {role === "admin" && (
                      <li>
                        <NavLink
                          className={styles["navigation-link"]}
                          to="/search"
                        >
                          Search
                        </NavLink>
                      </li>
                    )}

                    {role === "admin" && (
                      <li>
                        <NavLink
                          className={styles["navigation-link"]}
                          to="/insert"
                        >
                          Insert new specsheet (DS1)
                        </NavLink>
                      </li>
                    )}

                    {role === "admin" && (
                      <li>
                        <NavLink
                          className={styles["navigation-link"]}
                          to="/insert2"
                        >
                          Insert new specsheet (DS2)
                        </NavLink>
                      </li>
                    )}

                    {user.role === "admin" && (
                      <li>
                        <NavLink
                          className={styles["navigation-link"]}
                          to="/users"
                        >
                          Manage Users
                        </NavLink>
                      </li>
                    )}

                    {user.role === "admin" && (
                      <li>
                        <NavLink
                          className={styles["navigation-link"]}
                          to="/formsettings"
                        >
                          Form Settings
                        </NavLink>
                      </li>
                    )}

                    <li>
                      <FunctionalButton type="button" handleClick={signOut}>
                        Sign out
                      </FunctionalButton>
                    </li>
                  </>
                </ul>
              )}
            </nav>
          )}
        </div>
      </div>
    </div>
  );
}

export default Header;
